import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function JsonViewer({ value, label = "JSON", testId }) {
  const [copied, setCopied] = useState(false);
  const text = typeof value === "string" ? value : JSON.stringify(value || {}, null, 2);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("JsonViewer copy failed:", err);
    }
  };
  return (
    <div className="relative bg-slate-100 border border-slate-200 rounded-md" data-testid={testId}>
      <div className="flex items-center justify-between px-3 py-2 border-b border-slate-200 text-xs font-semibold text-slate-700 tracking-wide uppercase">
        <span>{label}</span>
        <button
          type="button"
          onClick={copy}
          data-testid={`${testId}-copy`}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-medium bg-white border border-slate-200 hover:bg-slate-50"
        >
          {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
          {copied ? "Copiado" : "Copiar"}
        </button>
      </div>
      <pre className="p-3 text-xs font-mono leading-relaxed text-slate-800 overflow-auto max-h-72 whitespace-pre-wrap break-all">
{text}
      </pre>
    </div>
  );
}
